import { z } from 'zod'

/**
 * Configure Zod v4 globally with improved error messages.
 *
 * In Zod v4, required fields that receive `undefined` show
 * "Invalid input: expected X, received undefined" instead of the Zod v3
 * "Required" message. This config restores a sensible "Required" message.
 *
 * See: https://github.com/colinhacks/zod/issues/4968
 */
const defaultLocaleError = z.locales.en().localeError

z.config({
  localeError: (issue) => {
    if (issue.code === 'invalid_type' && issue.input === undefined) {
      return 'Required'
    }
    return defaultLocaleError(issue)
  },
})
